export enum AdVideoStatus {
  ready = 'ready',
  processing = 'processing',
  error = 'error',
}

export interface AdVideo {
  id: number;
  embeddedHtml: string;
  length: number;
  permalinkUrl: string;
  source?: string;
  status: AdVideoStatus;
  processingProgress?: number;
  thumbnail?: string;
  title?: string;
  createdAt: number;
  updatedAt: number;
  /**
   * Fresh, short-lived signed URL to our own durable copy of the video in S3.
   * Present only when we have a stored copy and the response boundary was given a
   * signer. Unlike `source` (a Facebook fbcdn URL), this does not depend on the
   * business Facebook token, so it stays playable when the token is down. Never
   * persisted — regenerated per response.
   */
  storedSource?: string;
}

export const exampleAdVideo: AdVideo = {
  id: 1,
  embeddedHtml: '<iframe />',
  length: 12.34,
  permalinkUrl: 'link.me/fb',
  source: 'https://image.com',
  status: AdVideoStatus.ready,
  thumbnail: 'https://image.com',
  title: 'New Video',
  createdAt: 1595533091,
  updatedAt: 1595533091,
};
